module.exports = __webpack_public_path__ + "static/media/child.be390512.png";